import { getData, postData } from "@/api/index";
// import { * } from "@/services/server/publicInterface";
//行业分类
export async function getCompanyType() {
  let res = await getData("company.CompanyTypeController/tableListAction");
  return res.data;
}
//防骚扰平台
export async function getBlackPlatType() {
  let res = await getData("black.BlackPlatController/tableListAction");
  return res.data;
}
//代理商
export async function getAgentData() {
  let res = await getData("UserController/pageAction", {
    page: 1,
    role: 2,
    pagesize: 10000,
  });
  return res.data.data;
}
//代理商
export async function getAgentData1() {
  let res = await getData("UserController/directSonAction", {
    page: 1,
    pagesize: 10000,
  });
  return res.data.data;
}
//风控等级
export async function getStormTempType() {
  let res = await getData("storm.StormTempController/tableListAction");
  return res.data;
}
//授权商品
export async function getCallTypeList() {
  let res = await getData("call.CallSeatController/listAction");
  return res.data;
}
//企业
export async function getCompanyData() {
  let res = await getData("company.CompanyController/pageAction", {
    page: 1,
    pagesize: 10000,
  });
  return res.data.data;
}
//运营商种类
export async function getOperatorArr() {
  let res = await getData("call.IccidOperatorController/tableListAction");
  return res.data;
}
//直属下级代理商
export async function getDirectSonAction(params) {
  let res = await getData("UserController/directSonAction", params);
  return res.data.data;
}
export async function getCallTypeCardArr() {
  let res = await getData("call.CallTypeController/tableListAction");
  return res.data.filter((item) => item.is_card == 1);
}
